import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { AreaService } from '@commons/services/area/area.service';
import { Area } from '../../../commons/models/domain/Area';
import { NotificationService } from '@commons/services/notification/notification.service';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'tk-area-delete',
    templateUrl: './area-delete.component.html',
    styleUrls: ['./area-delete.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AreaDeleteComponent implements OnInit {

    @Input() public area!: Area;

    @Output() public onDelete: EventEmitter<any> = new EventEmitter<any>();

    public showDeleteModal = false;

    public inProgress = false;
    private confirmationTrans = '';
    constructor(
        private $service: AreaService,
        private $msg: NotificationService,
        private translateService: TranslateService
    ) {
      this.translateService.get('areas.remove-confirmation').subscribe(t => this.confirmationTrans = t);
    }

    ngOnInit() {

    }

    deleteArea() {
        this.showDeleteModal = true;
    }

    confirm() {
        this.inProgress = true;
        this.$service.deleteAreaDetails$(this.area!.Id).subscribe(result => {
            this.inProgress = false;
            this.showDeleteModal = false;
            this.$msg.showSuccess(this.confirmationTrans);
            this.onDelete.emit(null);
        }, error => this.inProgress = false);
    }

    close() {
        this.showDeleteModal = false;
    }

    deny() {
        this.showDeleteModal = false;
    }
}
